import React from 'react';
import { Card } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import CardItem from '@/components/cards/CardItem';
import CardHeader from '@/components/cards/CardHeader';
import urls, { codeUrl } from '@/constants/urls';
import SystemFlag from '@/components/SystemFlag';
import { vocabularyGroupings } from '../constants';
import vocabularyComponents from '../helper';
import VocabularyTools from '../containers/VocabularyTools';
import events from '../hooks/events';

const VocabularyCardItem = ({ category, upward, vocabulary }) => {
  const show = events.useShowSaveVocabulary(category, vocabulary);
  const { CardDescription } = vocabularyComponents[vocabulary.grouping];

  return (
    <CardItem className="aridhia-audit-list-item">
      <Card.Content>
        <CardHeader
          className="aridhia-vocabulary-list-ite"
          entity="vocabulary"
          href={codeUrl(urls.VOCABULARIES, vocabulary.code)}
          loading={vocabulary.updateStatus === states.PENDING}
          onClick={show}
          text={vocabulary.name}
        >
          <VocabularyTools
            category={category}
            iconSize="large"
            listItem
            upward={upward}
            vocabulary={vocabulary}
          />
        </CardHeader>
        <Card.Meta>
          <SystemFlag
            flush
            messageId={`vocabulary.grouping.${vocabulary.grouping}`}
            solid={[vocabularyGroupings.EMAIL_TEMPLATE].includes(vocabulary.grouping)}
          />
        </Card.Meta>
        <CardDescription vocabulary={vocabulary} />
      </Card.Content>
    </CardItem>
  );
};

export default VocabularyCardItem;
